<template>
  <div class="chart">
    <canvas ref="canvas" :width="width" :height="height"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'
import http from 'services/http'
import _ from 'lodash'
import { normalizeToDay } from 'utils/normalizers'
import { getDays } from 'utils/dates'

export default {
  // Expects data to be an array of objects { name, ts } (ts => timestamp)
  props: {
    data: { type: Array },
    title: { type: String },
    width: { type: Number, default: 400 },
    height: { type: Number, default: 300 },
  },
  computed: {
    dataDaily() {
      let dataDaily = {}
      getDays(28).forEach((d) => {
        dataDaily[d] = 0
      })

      const counted = _.countBy(this.data, (e) => normalizeToDay(e.ts))
      dataDaily = Object.assign(dataDaily, counted)

      dataDaily = _.toPairs(dataDaily).map((pair) => {
        return { x: pair[0], y: pair[1] }
      })

      dataDaily = _.sortBy(dataDaily, ['x'])
      return dataDaily
    },
  },
  watch: {
    data() {
      this.renderChart()
    },
  },
  mounted() {
    const self = this
    self.renderChart()
  },
  beforeDestroy() {
    this.chart.destroy()
  },
  methods: {
    renderChart() {
      const self = this

      if (this.chart) {
        this.chart.destroy()
      }

      var ctx = this.$refs.canvas.getContext('2d')
      this.gradient = this.createGradient(ctx)

      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          // labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
          datasets: [
            {
              label: `Number of ${self.title}`,
              data: this.dataDaily,
              hoverBackgroundColor: 'rgba(254,182,69,0.8)',
              pointBackgroundColor: 'rgba(254,182,69,0.8)',
              backgroundColor: this.gradient,
              borderColor: ['rgba(254,182,69,1)'],
              borderWidth: 1,
            },
          ],
        },
        options: {
          title: { display: true, text: self.title },
          responsive: true,
          legend: { display: false },
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {
                  displayFormats: { day: 'MMM DD' },
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      })
    },
    createGradient(ctx) {
      const gradient = ctx.createLinearGradient(0, 0, 0, 400)
      gradient.addColorStop(0, 'rgba(241,231,103,1)')
      gradient.addColorStop(1, 'rgba(254,182,69,1)')
      return gradient
    },
  },
}
</script>
